"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.STALLED = exports.HIRED_ATTORNEY = exports.DUPLICATE = exports.NOT_TRUTHFUL = exports.NO_RESPONSE = exports.RUDE = exports.COMPLEX_MOVING = exports.COMPLEX = exports.EXPENSIVE_ASSET = exports.PERSONAL_INJURY_CLAIMS = exports.AGREE_TO_HELP_TERMS = exports.TAX_RETURN_REQUIRED = exports.SPOUSE_FILING = exports.UNEXEMPT_TAX_REFUND = exports.TOO_MUCH_DEBT = exports.TOO_MUCH_CASH = exports.TOO_FEW_CREDITORS = exports.REPEAT_FILER = exports.PROMISE_TO_PAY = exports.PREVIOUS_BANKRUPTCY_ADMISSION = exports.PREVIOUS_BANKRUPTCY = exports.PERSONAL_PROPERTY = exports.OVER_INCOME_MONTHLY = exports.OVER_INCOME_IN_YEAR = exports.OVER_INCOME = exports.NO_LONGER_INTERESTED = exports.MONEY_INHERITANCE = exports.MONEY_ACCOUNT = exports.LIFE_INSURANCE = exports.LAWSUIT = exports.INTEREST_IN_REAL_ESTATE = exports.INSUFFICIENT_DEBT = exports.INCOME_POSITVE_SURPLUS = exports.REAL_ESTATE_OWNER = exports.HOMEOWNER = exports.FORECLOSURE = exports.EXEMPTION_CHOICES = exports.FEDERAL_EXEMPTIONS = exports.EXPENSIVE_AUTOMOBILE = exports.EXPENSES_NEGATIVE_SURPLUS = exports.EVICTION = exports.EDUCATION_FINANCIAL_ACCOUNT = exports.CURRENTLY_OPEN_BK_CASE = void 0;
var CURRENTLY_OPEN_BK_CASE = 'currentlyOpenBkCase'; // Supposed to replace PREVIOUS_BANKRUPTCY_ADMISSION

exports.CURRENTLY_OPEN_BK_CASE = CURRENTLY_OPEN_BK_CASE;
var EDUCATION_FINANCIAL_ACCOUNT = 'educationFinancialAccount';
exports.EDUCATION_FINANCIAL_ACCOUNT = EDUCATION_FINANCIAL_ACCOUNT;
var EVICTION = 'eviction';
exports.EVICTION = EVICTION;
var EXPENSES_NEGATIVE_SURPLUS = 'expensesNegativeSurplus';
exports.EXPENSES_NEGATIVE_SURPLUS = EXPENSES_NEGATIVE_SURPLUS;
var EXPENSIVE_AUTOMOBILE = 'expensiveAutomobile';
exports.EXPENSIVE_AUTOMOBILE = EXPENSIVE_AUTOMOBILE;
var FEDERAL_EXEMPTIONS = 'federalExemptions';
exports.FEDERAL_EXEMPTIONS = FEDERAL_EXEMPTIONS;
var EXEMPTION_CHOICES = 'exemptionChoices';
exports.EXEMPTION_CHOICES = EXEMPTION_CHOICES;
var FORECLOSURE = 'foreclosure';
exports.FORECLOSURE = FORECLOSURE;
var HOMEOWNER = 'homeowner';
exports.HOMEOWNER = HOMEOWNER;
var REAL_ESTATE_OWNER = 'realEstateOwner';
exports.REAL_ESTATE_OWNER = REAL_ESTATE_OWNER;
var INCOME_POSITVE_SURPLUS = 'incomePositveSurplus';
exports.INCOME_POSITVE_SURPLUS = INCOME_POSITVE_SURPLUS;
var INSUFFICIENT_DEBT = 'insufficientDebt';
exports.INSUFFICIENT_DEBT = INSUFFICIENT_DEBT;
var INTEREST_IN_REAL_ESTATE = 'interestInRealEstate';
exports.INTEREST_IN_REAL_ESTATE = INTEREST_IN_REAL_ESTATE;
var LAWSUIT = 'lawsuit';
exports.LAWSUIT = LAWSUIT;
var LIFE_INSURANCE = 'lifeInsurance';
exports.LIFE_INSURANCE = LIFE_INSURANCE;
var MONEY_ACCOUNT = 'moneyAccount';
exports.MONEY_ACCOUNT = MONEY_ACCOUNT;
var MONEY_INHERITANCE = 'moneyInheritance';
exports.MONEY_INHERITANCE = MONEY_INHERITANCE;
var NO_LONGER_INTERESTED = 'noLongerInterested';
exports.NO_LONGER_INTERESTED = NO_LONGER_INTERESTED;
var OVER_INCOME = 'overIncome';
exports.OVER_INCOME = OVER_INCOME;
var OVER_INCOME_IN_YEAR = 'overIncomeInYear';
exports.OVER_INCOME_IN_YEAR = OVER_INCOME_IN_YEAR;
var OVER_INCOME_MONTHLY = 'overIncomeMonthly';
exports.OVER_INCOME_MONTHLY = OVER_INCOME_MONTHLY;
var PERSONAL_PROPERTY = 'personalProperty'; // High value

exports.PERSONAL_PROPERTY = PERSONAL_PROPERTY;
var PREVIOUS_BANKRUPTCY = 'previousBankruptcy';
exports.PREVIOUS_BANKRUPTCY = PREVIOUS_BANKRUPTCY;
var PREVIOUS_BANKRUPTCY_ADMISSION = 'previousBankruptcyAdmission';
exports.PREVIOUS_BANKRUPTCY_ADMISSION = PREVIOUS_BANKRUPTCY_ADMISSION;
var PROMISE_TO_PAY = 'promiseToPay';
exports.PROMISE_TO_PAY = PROMISE_TO_PAY;
var REPEAT_FILER = 'repeatFiler'; // DA is using repeatFiler

exports.REPEAT_FILER = REPEAT_FILER;
var TOO_FEW_CREDITORS = 'tooFewCreditors';
exports.TOO_FEW_CREDITORS = TOO_FEW_CREDITORS;
var TOO_MUCH_CASH = 'tooMuchCash';
exports.TOO_MUCH_CASH = TOO_MUCH_CASH;
var TOO_MUCH_DEBT = 'tooMuchDebt';
exports.TOO_MUCH_DEBT = TOO_MUCH_DEBT;
var UNEXEMPT_TAX_REFUND = 'unexemptTaxRefund'; // Screener Reasons

exports.UNEXEMPT_TAX_REFUND = UNEXEMPT_TAX_REFUND;
var SPOUSE_FILING = 'spouseFiling';
exports.SPOUSE_FILING = SPOUSE_FILING;
var TAX_RETURN_REQUIRED = 'taxReturnRequired';
exports.TAX_RETURN_REQUIRED = TAX_RETURN_REQUIRED;
var AGREE_TO_HELP_TERMS = 'agreeToHelpTerms';
exports.AGREE_TO_HELP_TERMS = AGREE_TO_HELP_TERMS;
var PERSONAL_INJURY_CLAIMS = 'personalInjuryClaims'; // Changes to match DA reasons
// export const ITEM_OVER_TEN_K = 'itemOverTenK'; -> personalProperty
// export const FILER_MONTHLY_INCOME = 'filerMonthlyIncome'; -> overIncome
// export const HAS_REAL_ESTATE_OR_MORTGAGE = 'hasRealEstateOrMortgage'; -> homeowner
// export const DEBT_OVER_TEN_K = 'debtOverTenK'; -> insufficientDebt
// export const FILED_WITHIN_EIGHT_YEARS = 'filedWithinEightYears'; -> previousBankruptcy
// Team Reasons

exports.PERSONAL_INJURY_CLAIMS = PERSONAL_INJURY_CLAIMS;
var EXPENSIVE_ASSET = 'expensiveAsset';
exports.EXPENSIVE_ASSET = EXPENSIVE_ASSET;
var COMPLEX = 'complex';
exports.COMPLEX = COMPLEX;
var COMPLEX_MOVING = 'complexMoved';
exports.COMPLEX_MOVING = COMPLEX_MOVING;
var RUDE = 'rude';
exports.RUDE = RUDE;
var NO_RESPONSE = 'noResponse';
exports.NO_RESPONSE = NO_RESPONSE;
var NOT_TRUTHFUL = 'notTruthful';
exports.NOT_TRUTHFUL = NOT_TRUTHFUL;
var DUPLICATE = 'duplicate';
exports.DUPLICATE = DUPLICATE;
var HIRED_ATTORNEY = 'hiredAttorney'; // Automated

exports.HIRED_ATTORNEY = HIRED_ATTORNEY;
var STALLED = 'stalled';
exports.STALLED = STALLED;